import styled from 'styled-components';

export const WrapperTotalTickets = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 0.5fr 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  width: 100%;

  .section-title {
    grid-area: 1 / 1 / 2 / 7;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
    h1 {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .section-tickets {
    grid-area: 2 / 1 / 3 / 7;
    display: flex;
    flex-direction: row;
    width: 100%;
    text-align: center;
  }

  .ticket-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50px;
    margin: 10px;
    border-radius: 10px;
    strong {
      font-size: 12px;
      font-weight: bold;
    }
    .white-text {
      color: white;
      font-size: 25px;
    }
  }
`;

export const WrapperTotalTicketByStatus = styled.div`
  display: flex;
  margin: 30px;
  h3 {
    font-size: 18px;
    font-weight: bold;
  }

  .section-by-status {
    display: flex;
    width: 100%;
  }

  .section-filter {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: baseline;
    .section-estatus {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin: 3px;
      .section-square {
        width: 20px;
        height: 20px;
        margin: 4px;
      }
    }
    p {
      font-size: 10px;
    }
  }
`;

export const WrapperTotal = styled.div`
  display: flex;
  margin: 30px;
  height: 100%;
  h3 {
    font-size: 18px;
    font-weight: bold;
  }

  .section-by-total {
    margin-bottom: 20px;
  }

  .section-title {
    margin: 10px;
  }

  .section-chart {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    h2 {
      font-size: 14px;
      padding-bottom: 5px;
      border-bottom: 1px solid;
    }
  }
`;
